module.exports = __webpack_public_path__ + "img/gl-01.3070ab63.jpg";